import {FINISH_LOADING, START_LOADING} from '../actions/actionTypes';

// FYI: popup structure - {[id]: {isOpened, id, modalType, children}} (06.30.2020, Oleh);
const initialState = {
    loader: {
        isLoader: false,
        loadingCount: 0
    },
    popup: {},
    wizard: {activeStep: 0}
};

export default (state = initialState, {type, ...payload}) => {
    switch (type) {
        case START_LOADING: {
            const {isLoader} = payload;
            const loadingCount = state.loader.loadingCount + 1;
            const loader = {loadingCount, isLoader};

            return {...state, loader};
        }

        case FINISH_LOADING: {
            const loadingCount = state.loader.loadingCount - 1;
            const isLoader = state.loader.isLoader && !!loadingCount; // FYI: checking for request without loader (06.22.20, Oleh)
            const loader = {loadingCount, isLoader};

            return {...state, loader};
        }

        default: {
            return state;
        }
    }
};
